var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLlmGemini = function SvgLlmGemini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.833 8.94a12.9 12.9 0 0 1-4.045-2.728A12.84 12.84 0 0 1 10.443.347a.458.458 0 0 0-.886 0 12.844 12.844 0 0 1-3.345 5.865A12.84 12.84 0 0 1 .347 9.557a.458.458 0 0 0 0 .886q.933.235 1.82.617 2.31.995 4.045 2.728a12.83 12.83 0 0 1 3.345 5.865.458.458 0 0 0 .886 0q.235-.933.617-1.82a12.9 12.9 0 0 1 2.728-4.045 12.84 12.84 0 0 1 5.865-3.345.458.458 0 0 0 0-.886 12 12 0 0 1-1.82-.616"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "llm-gemini_svg__b",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10 0c.21 0 .392.143.443.347q.235.934.616 1.82a12.8 12.8 0 0 0 2.73 4.045 12.85 12.85 0 0 0 5.864 3.345.458.458 0 0 1 0 .886q-.934.235-1.82.616a12.8 12.8 0 0 0-4.045 2.73 12.85 12.85 0 0 0-3.345 5.864.458.458 0 0 1-.886 0 12.836 12.836 0 0 0-3.345-5.865 12.85 12.85 0 0 0-5.865-3.345.458.458 0 0 1 0-.886 12.844 12.844 0 0 0 5.865-3.345A12.84 12.84 0 0 0 9.557.347.46.46 0 0 1 10 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#llm-gemini_svg__a)",
    d: "M10 0c.21 0 .392.143.443.347q.235.934.616 1.82a12.8 12.8 0 0 0 2.73 4.045 12.85 12.85 0 0 0 5.864 3.345.458.458 0 0 1 0 .886q-.934.235-1.82.616a12.8 12.8 0 0 0-4.045 2.73 12.85 12.85 0 0 0-3.345 5.864.458.458 0 0 1-.886 0 12.836 12.836 0 0 0-3.345-5.865 12.85 12.85 0 0 0-5.865-3.345.458.458 0 0 1 0-.886 12.844 12.844 0 0 0 5.865-3.345A12.84 12.84 0 0 0 9.557.347.46.46 0 0 1 10 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#llm-gemini_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#llm-gemini_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE432",
    d: "M-1.805 15.635c2.31.82 4.966-.718 5.932-3.437C5.092 9.48 4.002 6.61 1.69 5.79s-4.967.718-5.932 3.436c-.966 2.72.125 5.589 2.436 6.41"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#llm-gemini_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FC413D",
    d: "M8.454 6.671c3.175 0 5.749-2.63 5.749-5.874 0-3.245-2.574-5.875-5.749-5.875S2.706-2.448 2.706.797 5.28 6.67 8.454 6.67"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#llm-gemini_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00B95C",
    d: "M6.22 25.459c3.314-.162 5.83-3.774 5.621-8.067-.21-4.293-3.067-7.642-6.38-7.48-3.315.162-5.83 3.773-5.621 8.067.21 4.293 3.066 7.642 6.38 7.48"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#llm-gemini_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00B95C",
    d: "M6.22 25.459c3.314-.162 5.83-3.774 5.621-8.067-.21-4.293-3.067-7.642-6.38-7.48-3.315.162-5.83 3.773-5.621 8.067.21 4.293 3.066 7.642 6.38 7.48"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#llm-gemini_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00B95C",
    d: "M9.54 22.861c2.778-1.69 3.522-5.54 1.66-8.599-1.86-3.058-5.621-4.167-8.4-2.477s-3.521 5.54-1.66 8.599C3 23.442 6.76 24.552 9.54 22.86"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#llm-gemini_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3186FF",
    d: "M20.769 13.25c3.123 0 5.654-2.437 5.654-5.445 0-3.007-2.531-5.444-5.654-5.444s-5.654 2.437-5.654 5.444 2.531 5.445 5.654 5.445"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#llm-gemini_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M-4.026 12.618c2.875 2.187 7.075 1.5 9.381-1.532s1.845-7.264-1.03-9.45C1.45-.551-2.75.136-5.057 3.168s-1.845 7.264 1.03 9.45"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#llm-gemini_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3186FF",
    d: "M10.706 15.85c3.432 2.36 7.981 1.702 10.16-1.468S22.033 6.729 18.6 4.369 10.618 2.667 8.439 5.837c-2.18 3.17-1.165 7.654 2.267 10.013"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#llm-gemini_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#749BFF",
    d: "M16.945-.72c.874 1.187-.248 3.495-2.505 5.155-2.258 1.66-4.795 2.043-5.668.856S9.02 1.796 11.278.136s4.794-2.044 5.667-.856"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#llm-gemini_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FC413D",
    d: "M9.778 4.963c3.49-3.238 4.688-7.622 2.675-9.791S5.98-6.133 2.49-2.895C-1 .343-2.199 4.727-.187 6.896c2.013 2.17 6.474 1.305 9.965-1.933"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#llm-gemini_svg__m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFEE48",
    d: "M2.623 16.592c2.074 1.485 4.456 1.71 5.32.504.863-1.207-.119-3.389-2.193-4.873-2.075-1.485-4.457-1.71-5.32-.504s.118 3.388 2.193 4.873"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "llm-gemini_svg__c",
    width: 12.104,
    height: 13.319,
    x: -6.109,
    y: 4.053,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_13749_13701",
    stdDeviation: 0.758
  })), /*#__PURE__*/React.createElement("filter", {
    id: "llm-gemini_svg__d",
    width: 26.155,
    height: 26.408,
    x: -4.623,
    y: -12.408,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_13749_13701",
    stdDeviation: 3.665
  })), /*#__PURE__*/React.createElement("filter", {
    id: "llm-gemini_svg__e",
    width: 24.487,
    height: 28.02,
    x: -6.403,
    y: 3.675,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_13749_13701",
    stdDeviation: 3.115
  })), /*#__PURE__*/React.createElement("filter", {
    id: "llm-gemini_svg__f",
    width: 24.487,
    height: 28.02,
    x: -6.403,
    y: 3.675,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_13749_13701",
    stdDeviation: 3.115
  })), /*#__PURE__*/React.createElement("filter", {
    id: "llm-gemini_svg__g",
    width: 24.572,
    height: 25.119,
    x: -6.116,
    y: 4.764,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_13749_13701",
    stdDeviation: 3.115
  })), /*#__PURE__*/React.createElement("filter", {
    id: "llm-gemini_svg__h",
    width: 23.15,
    height: 22.732,
    x: 9.194,
    y: -3.56,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_13749_13701",
    stdDeviation: 2.961
  })), /*#__PURE__*/React.createElement("filter", {
    id: "llm-gemini_svg__i",
    width: 24.081,
    height: 24.272,
    x: -11.891,
    y: -5.009,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_13749_13701",
    stdDeviation: 2.683
  })), /*#__PURE__*/React.createElement("filter", {
    id: "llm-gemini_svg__j",
    width: 24.309,
    height: 23.897,
    x: 2.498,
    y: -1.839,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_13749_13701",
    stdDeviation: 2.396
  })), /*#__PURE__*/React.createElement("filter", {
    id: "llm-gemini_svg__k",
    width: 17.342,
    height: 15.967,
    x: 4.187,
    y: -5.698,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_13749_13701",
    stdDeviation: 2.144
  })), /*#__PURE__*/React.createElement("filter", {
    id: "llm-gemini_svg__l",
    width: 21.837,
    height: 21.359,
    x: -4.785,
    y: -9.646,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_13749_13701",
    stdDeviation: 1.811
  })), /*#__PURE__*/React.createElement("filter", {
    id: "llm-gemini_svg__m",
    width: 17.105,
    height: 15.894,
    x: -4.366,
    y: 6.46,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_13749_13701",
    stdDeviation: 2.241
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "llm-gemini_svg__a",
    x1: 5.685,
    x2: 16.073,
    y1: 13.382,
    y2: 4.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4893FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#4893FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#969DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD99FE"
  })))));
};
export default SvgLlmGemini;